import { render, staticRenderFns } from "./outordersummary.vue?vue&type=template&id=b7b25044&scoped=true&"
import script from "./outordersummary.vue?vue&type=script&lang=js&"
export * from "./outordersummary.vue?vue&type=script&lang=js&"
import style0 from "./outordersummary.vue?vue&type=style&index=0&id=b7b25044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b25044",
  null
  
)

export default component.exports